import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-configuracion-sede-registrar',
  templateUrl: './configuracion-sede-registrar.component.html',
  styleUrls: ['./configuracion-sede-registrar.component.css']
})
export class ConfiguracionSedeRegistrarComponent implements OnInit {  
  model: ISedeModel = new SedeModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  constructor(
    private router: Router,
    private companiaService: CompaniaService,
    private sedeService: SedeService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_TIPO_VISITA).subscribe((data) => {
      this.listaEstados = data.items;
    });

    let filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.sedeService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("La Sede fue registrada");
            this.router.navigate(['/configuracion', 'sedes']);  
          });
        }
      });
    }
  }
}
